import { Box, Typography } from "@mui/material"
import BaseImage from "../BaseImage"
import IconSupport from "../../assets/images/icons/icon-support.svg"
import CloseIcon from '@mui/icons-material/Close';

import { useDispatch } from "react-redux";
import { openModal } from "../../store";

const ConciergeEditItem = ({ item, patient_name, onConfirm }) => {
  const dispatch = useDispatch() 

  const handleClickRemoveNote = (item) => {
    dispatch(
      openModal({
        currentModal: 'CONFIRM_STAFF_MODAL',
        modalProps: {
          staff_name: item?.staff?.name,
          staff_role: item?.title,
          patient_name,
          confirm_type: true,
          onConfirm: onConfirm,
        }
    }))
  }

  const capitalize = (text) => {
    if (!text) return ''; 
    return text.charAt(0).toUpperCase() + text.slice(1).toLowerCase();
  };
  
  return (
    <Box
      sx={{
        height: '100%',
        borderRadius: '16px',
        padding: '16px',
        boxShadow: '0px 2px 10px 0px #5B87EF33',
        mt: '16px',
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'flex-start',
        flexGrow: 1,
      }}
    >
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          width: '100%',
          height: '100%',
          pr: '8px',
          justifyContent: 'space-between'
        }}
      >
        <Box
          sx={{
            display: 'flex',
            flexDirection: 'column'
          }}
        >
          <Typography variant="h3">{item?.staff?.name}</Typography>
          <Typography variant="subText" color='primary.mainBlue' mt='8px' whiteSpace={'pre-wrap'}>{capitalize(item?.role)}</Typography>
        </Box>
        <Box
          sx={{
            borderTop: '1px solid',
            borderColor: 'primary.lightGray',
            pt: '8px'
          }}
        >
          <Box
            sx={{
              display: 'flex',
              flexWrap: 'wrap',
              alignItems: 'center'
            }}
          >
            <Typography variant="subText" color='primary.darkGray'>
              Phone:
            </Typography>
            <Box
              sx={{
                ml: '8px'
              }}
            >
              <Typography variant="subText" color='background.black'>{item?.staff?.staffProfile?.phone || 'XXX-XXX-XXXX'}</Typography>
            </Box>
          </Box>
        </Box>
      </Box>
      <Box
        sx={{
          width: '100px',
          display: 'flex',
          justifyContent: 'center'
        }}
      >
        <BaseImage
          src={item?.staff?.avatarUrl || IconSupport}
          sx={{
            minWidth: item?.staff?.avatarUrl ? '80px' : '40px',
            width: item?.staff?.avatarUrl ? '80px' : '40px',
            height: item?.staff?.avatarUrl ? '80px' : '40px',
          }}
          sximage={{
            borderRadius: '8px',
            objectFit: 'cover'
          }}
        />
      </Box>
      <CloseIcon
        sx={{
          color: 'neturals.black',
          mr: '10px',
          ml: '24px',
        }}
        onClick={() => handleClickRemoveNote(item)}
      />
    </Box>
  )
}

export default ConciergeEditItem